<template>
  <ExpenseFeeModalSectionDetails
    :active="active"
    :form="form"
    :options="options"
    :entity-label="text.sections.sharedDetails.entityLabel"
    :text="text.sections.sharedDetails"
    :common-text="text.sections.common"
  />
</template>

<script>
import ExpenseFeeModalSectionDetails from '@/components/expensesFees/modal/ExpenseFeeModalSections/ExpenseFeeModalSectionDetails.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('expenses');

export default {
  name: 'ExpenseModalSectionDetails',
  components: {
    ExpenseFeeModalSectionDetails,
  },
  data() {
    return {
      text,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>
